import { useState } from 'react';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

import classes from './SelectEmail.module.css';

const SelectEmail = props => {
  const [emailSelected, setEmailSelected] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = event => {
    setEmailSelected(event.target.value);
  };

  const sendData = () => {
    setLoading(true);
  };

  return (
    <div className={classes.container}>
      <p className={classes.title}>Crea tu cuenta de correo</p>
      <p className={classes.subText}>
        Elige tu correo institucional para ingresar al Campus UDC
      </p>
      <p>Alumno: {props.emailsData.studentName}</p>
      <p>Programa: {props.emailsData.programName}</p>
      <p>
        Elige tu correo institucional de las siguientes opciones
        disponibles:
      </p>
      <table className={classes.standardTable}>
        <tr>
          <td>
            <div className={classes.paymentMatriculaContent}>
              <div>
                <div
                  className={classes.pendingApplicationRow}
                  style={{ paddingBottom: '1%' }}
                >
                  <div
                    className={classes.pendingApplicationColumn}
                    style={{ flexBasis: '50%' }}
                  >
                    <table>
                      <tr>
                        <td
                          style={{
                            borderRightStyle: 'solid',
                            borderRightColor: '#464872',
                            borderRightWidth: 2
                          }}
                        >
                          <FormControl component="fieldset">
                            <RadioGroup
                              value={emailSelected}
                              onChange={handleChange}
                            >
                              {props.emailsData.emailOptions.map(
                                option => {
                                  return (
                                    <FormControlLabel
                                      key={option.key}
                                      className={
                                        classes.radioControl
                                      }
                                      classes={
                                        classes.radioControlLabel
                                      }
                                      value={option.value}
                                      control={<Radio />}
                                      label={option.value}
                                    />
                                  );
                                }
                              )}
                            </RadioGroup>
                          </FormControl>
                        </td>
                        <td className={classes.udcDomainLabel}>
                          <div>@universidaddelasciencias.edu.mx</div>
                        </td>
                      </tr>
                    </table>
                  </div>

                  <div
                    className={classes.pendingApplicationColumn}
                    style={{ flexBasis: '50%' }}
                  >
                    <div className={classes.selectEmail}>
                      <p>Correo seleccionado:</p>
                      <p className={classes.dynamicMail}>
                        {emailSelected != ''
                          ? emailSelected +
                            '@universidaddelasciencias.edu.mx'
                          : '@universidaddelasciencias.edu.mx'}
                      </p>
                      {!loading ? (
                        <Button
                          onClick={sendData}
                          disabled={
                            emailSelected == '' ? true : false
                          }
                          className={classes.createEmailBtn}
                        >
                          <div>
                            <p style={{ margin: '-5px 0px 0px' }}>
                              Crear cuenta de correo
                            </p>
                            <p
                              style={{
                                margin: '-12px 0px 0px',
                                fontSize: 14
                              }}
                            >
                              Una vez creado no podrás cambiarlo
                            </p>
                          </div>
                        </Button>
                      ) : (
                        <figure className={classes.loadingImage}>
                          <img
                            className={classes.img}
                            src="https://d1g6c01s9ssd7h.cloudfront.net/img/preloader.png"
                            alt="loading"
                          />
                        </figure>
                      )}

                      <p style={{ fontSize: 16, color: '#5b6364' }}>
                        Una vez elegido no podras cambiarlo
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  );
};

SelectEmail.propTypes = {
  // eslint-disable-next-line react/require-default-props
  emailsData: PropTypes.array
};

export default SelectEmail;
